// export const BASE_URL = "http://localhost:8000/office"
// export const IMAGE_URL = "http://localhost:8000"

// export const BASE_URL = "http://192.168.25.119/branch/Api"
// export const BASE_URL = "https://tabaq.ae/branch/Api"
export const BASE_URL = "https://api.tabaq.in/office"
export const IMAGE_URL = "https://api.tabaq.in"